export default __webpack_public_path__ + "static/media/merge-cells.bb981cff.svg";